class NavigationPromo {

  constructor () {
    this.ele = document.getElementById('navigation-promo');
    this.btn = document.getElementById('navigation-promo-close');
    this.container;
    this.btnToggles = document.querySelectorAll('[data-toggle-promo]');
    this.overlay = document.getElementById('navigation-promo-overlay');
    this.handleClick = this.handleClick.bind(this);
    this.handleToggleClick = this.handleToggleClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  /* remove promo bar */
  handleClick (e) {
    this.ele.remove();
    if (typeof this.container != "undefined") {
      this.container.classList.remove("promo");
    }
    // or transition stuff ...
  }

  /* open/close promo overlay */
  handleToggleClick (e) {
    if (this.overlay.classList.contains('active')) {
      this.overlay.classList.remove('active');
    } 
    else {
      this.overlay.classList.add('active');
    }
  }

  /* close promo overlay */
  handleCloseClick (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.target == this.overlay) {
      this.overlay.classList.remove('active');
    }
    else if (['I','BUTTON'].includes(e.target.tagName)) {
      this.overlay.classList.remove('active');
    }
  }

  init () {
    if (this.ele != null && this.btn != null) {
        this.btn.addEventListener('click', this.handleClick);

      this.container = this.ele.closest(".navigation");
      if (this.container != null) {
        this.container.classList.add("promo");
      }
    }
    window.addEventListener('resize', this.setPromoHeightVar);

    if (this.overlay != null) {
      if (this.btnToggles != null && this.btnToggles.length > 0) {
        this.btnToggles.forEach((btn) => {
          if (btn != null) {
            btn.addEventListener('click', this.handleToggleClick);
          }
        });
      }

      this.overlay.addEventListener('click', this.handleCloseClick);
    }
  }
}

export default NavigationPromo;